module.exports = __webpack_public_path__ + "img/alloys@2x.677702c.webp";